<template>
  <div class="navbar">
    <div class="logo">
      <img src="../../assets/img/friendgroup.png" alt="" srcset="" />
      <p>友圈</p>
    </div>
    <div>
      <span v-if="isLogin" @click="openRegisterWindows" class="btn">註冊</span>
      <span v-if="isLogin" @click="openLoginWindows" class="btn-login">登入</span>
      <span v-else @click="SET_LOGOUT()" class="btn-login">登出</span>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'NavBar',
  computed: {
    ...mapState(['isLogin'])
  },
  methods: {
    ...mapMutations(['SET_OPEN_WINDOW_STATUS', 'SET_OPEN_REGISTER_STATUS', 'SET_LOGOUT', 'SET_REGISTER_FALSE_STATUS', 'SET_SHOW_MODAL']),
    // 登入元件開啟
    // openLoginWindows() {
    //   this.SET_OPEN_WINDOW_STATUS(true);
    // },
    // 開啟註冊選單
    // openRegisterWindows() {
    //   this.SET_OPEN_REGISTER_STATUS(true);
    //   this.SET_REGISTER_FALSE_STATUS('');
    // }

    openRegisterWindows() {
      this.SET_SHOW_MODAL({ isShow: true, modalName: 'Register' });
      this.SET_OPEN_WINDOW_STATUS(true);
      this.SET_REGISTER_FALSE_STATUS('');
    },

    openLoginWindows() {
      this.SET_SHOW_MODAL({ isShow: true, modalName: 'login' });
      this.SET_OPEN_WINDOW_STATUS(true);
    }
  }
};
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
.btn {
  margin: 15px 12px 15px 15px;
  padding: 7px 27px;
  color: #f08f00 !important;
  border: 1px solid #f08f00;
  border-radius: 50px;
  cursor: pointer;
}

.btn-login {
  margin: 15px 15px 15px 12px;
  padding: 7px 27px;
  color: #fff !important;
  background-color: #f08f00;
  border: 1px solid #f08f00;
  border-radius: 50px;
  cursor: pointer;
}
.navbar {
  width: 100%;
  padding: 30px 70px 30px 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.logo {
  display: flex;
  align-items: center;
  color: #f08f00;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  p {
    margin-left: 8px;
    cursor: default;
  }
  img {
    max-width: 100%;
  }
}

@media (max-width: 575px) {
  .navbar {
    padding: 15px;
  }
  .btn-login {
    padding: 5px 18px;
  }
}
</style>
